import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/images/users1x.png'


const _hoisted_1 = { class: "refereeDetailView" }
const _hoisted_2 = {
  key: 0,
  class: "pageConetent"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "head1" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Back to Reference ")
const _hoisted_6 = { class: "head2" }
const _hoisted_7 = { class: "rreport" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Reference report", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" for ")
const _hoisted_10 = { class: "nams" }
const _hoisted_11 = { class: "icn" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Download reference report ")
const _hoisted_13 = { class: "head3" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Candidate Name: ")
const _hoisted_15 = { class: "jtitle" }
const _hoisted_16 = { class: "head3" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Job title: ")
const _hoisted_18 = { class: "jtitle" }
const _hoisted_19 = { class: "head4" }
const _hoisted_20 = { class: "dateS" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Candidate started working here: ")
const _hoisted_22 = { class: "dayS" }
const _hoisted_23 = { class: "dateS" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Candidate finished working here: ")
const _hoisted_25 = { class: "dayS" }
const _hoisted_26 = { class: "body" }
const _hoisted_27 = { class: "head1" }
const _hoisted_28 = { class: "left" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "user1"
}, null, -1)
const _hoisted_30 = { class: "datailas" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h2", null, "Referee Details", -1)
const _hoisted_32 = { class: "right" }
const _hoisted_33 = {
  class: "rdetails",
  ref: "rdetails"
}
const _hoisted_34 = { class: "personalDetails" }
const _hoisted_35 = { class: "left" }
const _hoisted_36 = { class: "right" }
const _hoisted_37 = { class: "name" }
const _hoisted_38 = { class: "company" }
const _hoisted_39 = { class: "relationship" }
const _hoisted_40 = { class: "left" }
const _hoisted_41 = { class: "datailas" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("h2", null, "Relationship to candidate", -1)
const _hoisted_43 = { class: "right" }
const _hoisted_44 = { class: "datailas" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("h2", null, "Known candidate for", -1)
const _hoisted_46 = {
  class: "questionSec",
  ref: "questionSec"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "datailas" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Questions"),
    /*#__PURE__*/_createElementVNode("small", null, "These are the questions you asked the referee about the candidate.")
  ])
], -1)
const _hoisted_48 = { class: "qprofile" }
const _hoisted_49 = { class: "Qcontent" }
const _hoisted_50 = { class: "Qnumber" }
const _hoisted_51 = {
  key: 0,
  class: "answer"
}
const _hoisted_52 = {
  key: 1,
  class: "answer"
}
const _hoisted_53 = {
  key: 2,
  class: "answer"
}
const _hoisted_54 = { key: 0 }
const _hoisted_55 = {
  key: 0,
  style: {"display":"flex"}
}
const _hoisted_56 = { key: 1 }
const _hoisted_57 = {
  key: 1,
  class: "spinners"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowLeftOutlined = _resolveComponent("ArrowLeftOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_DownloadOutlined = _resolveComponent("DownloadOutlined")!
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_InsertRowBelowOutlined = _resolveComponent("InsertRowBelowOutlined")!
  const _component_CalendarOutlined = _resolveComponent("CalendarOutlined")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_SendOutlined = _resolveComponent("SendOutlined")!
  const _component_BankOutlined = _resolveComponent("BankOutlined")!
  const _component_PhoneOutlined = _resolveComponent("PhoneOutlined")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_HeartOutlined = _resolveComponent("HeartOutlined")!
  const _component_CheckCircleOutlined = _resolveComponent("CheckCircleOutlined")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_rate = _resolveComponent("a-rate")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.refereeDetails)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_button, {
                class: "back-btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.backToReference()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ArrowLeftOutlined),
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _hoisted_9,
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.refereeDetails.candidate_name), 1)
              ]),
              (_ctx.commonService.checkPermission('Referee', 'download'))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "download",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadPdf()))
                  }, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_DownloadOutlined)
                    ]),
                    _hoisted_12
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_UserOutlined),
              _hoisted_14,
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.refereeDetails.candidate_name), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_InsertRowBelowOutlined),
              _hoisted_17,
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.refereeDetails.candidate_job), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_CalendarOutlined),
                _hoisted_21,
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.moment(_ctx.refereeDetails.work_start, "YYYY-MM-DD").format(
                "MMMM YYYY"
              )), 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_CalendarOutlined),
                _hoisted_24,
                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.moment(_ctx.refereeDetails.work_end, "YYYY-MM-DD").format("MMMM YYYY")), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("small", null, "Details submitted on " + _toDisplayString(_ctx.refereeDetails.created_at), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", {
                  class: _normalizeClass(["sMenu", _ctx.activeI === 'rdetails' ? 'active' : '']),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goto('rdetails')))
                }, " Details ", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["sMenu", _ctx.activeI === 'questionSec' ? 'active' : '']),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goto('questionSec')))
                }, " Questions ", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["sMenu", _ctx.activeI === 'commentsSec' ? 'active' : '']),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goto('commentsSec')))
                }, " Comments ", 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_a_row, { gutter: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 24,
                    lg: 24,
                    xl: 10
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_a_avatar, {
                            src: 
                      'https://ui-avatars.com/api/?background=57429d&name=' +
                      _ctx.refereeDetails.referee_name +
                      '&rounded=true&color=ffffff'
                    
                          }, null, 8, ["src"])
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.refereeDetails.referee_name), 1),
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", null, [
                              _createVNode(_component_SendOutlined),
                              _createTextVNode(" " + _toDisplayString(_ctx.refereeDetails.email), 1)
                            ]),
                            _createElementVNode("li", _hoisted_38, [
                              _createVNode(_component_BankOutlined),
                              _createTextVNode(" " + _toDisplayString(_ctx.refereeDetails.company), 1)
                            ]),
                            _createElementVNode("li", null, [
                              _createVNode(_component_PhoneOutlined),
                              _createTextVNode(_toDisplayString(_ctx.refereeDetails?.phone ? _ctx.refereeDetails?.phone : "--"), 1)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 24,
                    lg: 24,
                    xl: 14
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _createVNode(_component_HeartOutlined),
                          _createElementVNode("div", _hoisted_41, [
                            _hoisted_42,
                            _createElementVNode("h3", null, _toDisplayString(_ctx.refereeDetails.referee_relationship), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _createVNode(_component_CheckCircleOutlined),
                          _createElementVNode("div", _hoisted_44, [
                            _hoisted_45,
                            _createElementVNode("h3", null, _toDisplayString(_ctx.refereeDetails.candidate_known), 1)
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ], 512),
            _createElementVNode("div", _hoisted_46, [
              _hoisted_47,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.refereeDetails.profiles, (profile, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("h2", null, _toDisplayString(profile.profile_name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profile.questions, (question, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "singleQues",
                        key: question.id
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_50, [
                            _createTextVNode(_toDisplayString(index + 1) + ". ", 1),
                            _createElementVNode("label", null, _toDisplayString(question.question), 1)
                          ]),
                          (question.question_type == 'Datepicker')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(question.answers.length
                        ? question.answers[0].answer != "" ? _ctx.moment(question.answers[0].answer).format("DD-MM-YYYY") : ''
                        : ""), 1))
                            : (question.question_type == 'Rating')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                  _createVNode(_component_a_rate, {
                                    value: +question.answers[0].answer,
                                    "allow-half": "",
                                    disabled: ""
                                  }, null, 8, ["value"])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                  (question.field_type == 'multiple')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                        (question.answers.length)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answers[0].formatted_answer, (answer) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: answer.id,
                                                  style: {"margin":"0 10px 0 0"}
                                                }, _toDisplayString(answer.value) + " , ", 1))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(question.answers.length ? question.answers[0].answer : ""), 1))
                                ]))
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              }), 128))
            ], 512)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.pageLoder)
      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
          _createVNode(_component_a_spin)
        ]))
      : _createCommentVNode("", true)
  ]))
}